export default {
  key: 'react',
  lang: 'javascript',
  generate: ({ baseUrl, websiteToken }) => `// TolaWidget.jsx
import { useEffect } from 'react';

const BASE_URL = '${baseUrl}';
const WEBSITE_TOKEN = '${websiteToken}';
const SCRIPT_ID = 'tola-sdk';

export default function TolaWidget() {
  useEffect(() => {
    // Guard against a second injection in React strict mode / remounts.
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = BASE_URL + '/packs/js/sdk.js';
    script.async = true;
    script.onload = () => {
      window.tolaSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });
    };
    document.body.appendChild(script);
  }, []);

  return null;
}

// Usage — render it once, near the root of your app:
//
// import TolaWidget from './TolaWidget';
//
// export default function App() {
//   return (
//     <>
//       <Routes />
//       <TolaWidget />
//     </>
//   );
// }
`,
};
